<template>
  <div class="container">
    <el-row style="margin-bottom: 10px">
      <el-col :span="12" style="color: #028D66">
        <span style="margin-right: 20px">
          项目ID:{{ project_id }}
        </span>
        <span>
          项目名称：{{ project_name }}
        </span>
      </el-col>
    </el-row>

    <el-button type="primary" plain size="small" round @click="exportExcel('trouble')">按隐患生成台账</el-button>
    <el-button type="primary" plain size="small" round @click="exportExcel('location')">按位置生成台账</el-button>
    <el-button type="primary" plain size="small" round @click="exportSites">生成所有场所台账</el-button>
    <el-button type="primary" plain size="small" round @click="exportYWCSites">生成已完成场所台账</el-button>
    <el-button type="primary" plain size="small" round @click="exportGzs">生成已完成场所告知书(无图)</el-button>
    <el-button type="primary" plain size="small" round @click="exportGzsPic">生成已完成场所告知书(有图)</el-button>
    <el-button type="primary" plain size="small" round @click="exportReport">生成所有已完成场所初检报告</el-button>
    <el-button type="primary" plain size="small" round @click="exportSitesReport">按场所ID生成已完成场所初检报告</el-button>
    <el-button type="primary" plain size="small" round @click="exportYWCFJReports">生成所有已完成复检场所报告</el-button>
    <el-button type="primary" plain size="small" round @click="exportFjSitesReport">按场所ID生成已完成复检报告</el-button>
    <hr>
    <!--表格-->
    <el-table :data="tableData"  stripe border ref="multipleTable">
      <el-table-column border min-width="70" label="类型" prop="task_type"></el-table-column>
      <el-table-column border min-width="70" label="状态" prop="task_status"></el-table-column>
      <el-table-column border min-width="70" label="开始时间" prop="created_time"></el-table-column>
      <el-table-column border min-width="70" label="处理时长" prop="handled_time"></el-table-column>
      <el-table-column border min-width="70" label="创建人" prop="creator"></el-table-column>
      <el-table-column border min-width="70" label="下载人员" prop="downloaders">
        <template v-slot:default="scope">
          <el-popover placement="top" trigger="hover" :popper-class="'downloaders-popover'">
            <el-row v-for="(downloader, index) in scope.row.downloaders.split(';')" :key="index">
              <el-col :span="24">{{ downloader }}</el-col>
            </el-row>
            <div slot="reference" class="ellipsis">{{
        scope.row.downloaders.length > 10 ? scope.row.downloaders.substr(0, 10) + '...' : scope.row.downloaders
      }}
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column border label="操作" min-width="120" fixed="right">
        <template v-slot="scope">
          <el-button @click="handleDownload(scope.row)" type="text" size="small">下载</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination style="margin-top:25px" @size-change="changePageSize" @current-change="changePage"
      :current-page.sync="pagination.current_page" :page-size="pagination.per_page"
      layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
    <!--对话框-->
    <el-dialog title="按场所ID生成报告书" :visible.sync="reportModel.isShow" width="600px" @close="onAddClose">
      <el-form ref="reportForm" :model="reportModel" label-width="80px" size="small">
        <el-input type="textarea" v-model="reportModel.site_ids" placeholder="请输入场所ID，用逗号分隔,比如：10001,10002"
          style="width: 100%; margin-top: 10px" rows="8"></el-input>
        <el-form-item style="margin-left:120px;margin-top: 30px">
          <el-button type="primary" @click="onAdd">生成</el-button>
          <el-button type="info" @click="onAddClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog :visible.sync="fjReportModel.isShow" width="600px" @close="onFjAddClose">
      <span slot="title">
        按场所ID生成
        <span style="color: red; font-weight: bold;">复检报告书</span>
      </span>
      <el-form ref="reportForm" :model="fjReportModel" label-width="80px" size="small">
        <el-input type="textarea" v-model="fjReportModel.site_ids" placeholder="请输入场所ID，用逗号分隔,比如：10001,10002"
          style="width: 100%; margin-top: 10px" rows="8"></el-input>
        <el-form-item style="margin-left:120px;margin-top: 30px">
          <el-button type="primary" @click="onFjAdd">生成</el-button>
          <el-button type="info" @click="onFjAddClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>

export default {
  data() {
    return {
      project_id: '',
      project_name: '',
      query: { task_id: "", task_type: "", creator: "", },
      pagination: { current_page: 1, total: 1, per_page: 10, },
      tableData: [],
      is_admin: false,
      reportModel: {
        isShow: false,
        site_ids: ''
      },
      fjReportModel: {
        isShow: false,
        site_ids: ''
      }
    }
  },
  methods: {
    //生成复检完成的复检报告
    async exportYWCFJReports() {
      try {
        await this.$Api.post('export_ywc_fj_reports', { project_id: this.project_id,site_ids:'' })
        await new Promise(resolve => setTimeout(resolve, 2000));
        await this.getList()
        this.$message.success("任务处理中，请等待一定时间刷新该页面，在列表中下载")
      } catch (e) {
        this.$notify({ title: '任务失败，请联系管理员', message: e.errormsg })
      }
    },
    //导出所有场所台账
    async exportSites() {
      try {
        await this.$Api.post('export_all_sites', { project_id: this.project_id })
        await new Promise(resolve => setTimeout(resolve, 2000));
        await this.getList()
        this.$message.success("任务处理中，请等待一定时间刷新该页面，在列表中下载")
      } catch (e) {
        this.$notify({ title: '任务失败，请联系管理员', message: e.errormsg })
      }
    },
    //导出已完成场所台账
    async exportYWCSites() {
      try {
        let res = await this.$Api.post('export_ywc_sites', { project_id: this.project_id })
        if (res) {
          let elem = document.createElement("iframe");
          elem.src = res.file_url;
          elem.style.display = "none";
          document.body.appendChild(elem);
        }
        this.$notify({ title: '导出成功', message: "导出成功" })
      } catch (e) {
        this.$notify({ title: '导出失败', message: e.errormsg })
      }
    },
    async handleDownload(row) {
      if (row.file_url !== null) {
        let elem = document.createElement("iframe");
        elem.src = row.file_url;
        elem.style.display = "none";
        document.body.appendChild(elem);
        try {
          await this.$Api.post('update_task_downloader', { id: row.id })
          await this.getList()
        } catch (e) {
          this.$notify({ title: '文件不存在，不能下载', message: e.errormsg })
        }
      } else {
        this.$notify({ title: '下载错误', message: '文件不存在，不能下载' })
      }
    },
    async exportExcel(type) {
      try {
        await this.$Api.post('export_troubles', { project_id: this.project_id, type: type })
        await new Promise(resolve => setTimeout(resolve, 2000));
        await this.getList()
        this.$message.success("任务处理中，请等待一定时间刷新该页面，在列表中下载")
      } catch (e) {
        this.$notify({ title: '任务处理失败', message: e.errormsg })
      }
    },
    async exportGzs() {
      try {
        await this.$Api.post('generate_gzs', { project_id: this.project_id })
        await new Promise(resolve => setTimeout(resolve, 2000));
        await this.getList()
        this.$message.success("任务处理中，请等待一定时间刷新该页面，在列表中下载")
      } catch (e) {
        this.$notify({ title: '任务处理失败', message: e.errormsg })
      }
    },
    async exportGzsPic() {
      try {
        await this.$Api.post('generate_gzs_pic', { project_id: this.project_id })
        await new Promise(resolve => setTimeout(resolve, 2000));
        await this.getList()
        this.$message.success("任务处理中，请等待一定时间刷新该页面，在列表中下载")
      } catch (e) {
        this.$notify({ title: '任务处理失败', message: e.errormsg })
      }
    },
    //按场所ID生成已完成场所初检报告
    async exportSitesReport() {
      this.reportModel.isShow = true
    },
    async onAdd() {
      if (!this.reportModel.site_ids || this.reportModel.site_ids.length === 0) {
        this.$notify({ title: '场所ID不能为空', message: '场所ID不能为空' })
        return
      }
      try {
        await this.$Api.post('generate_sites_reports', {
          project_id: this.project_id,
          site_ids: this.reportModel.site_ids
        })
        await new Promise(resolve => setTimeout(resolve, 2000));
        this.reportModel.isShow = false;
        await this.getList()
        this.$message.success("任务处理中，请等待一定时间刷新该页面，在列表中下载")
      } catch (e) {
        this.$notify({ title: '任务处理失败', message: e.errormsg })
      }
    },
    onAddClose() {
      this.reportModel.isShow = false
    },
    //按场所ID生成已完成复检报告
    async exportFjSitesReport() {
      this.fjReportModel.isShow = true
    },
    async onFjAdd() {
      if (!this.fjReportModel.site_ids || this.fjReportModel.site_ids.length === 0) {
        this.$notify({ title: '场所ID不能为空', message: '场所ID不能为空' })
        return
      }
      try {
        await this.$Api.post('generate_fj_sites_reports', {
          project_id: this.project_id,
          site_ids: this.fjReportModel.site_ids
        })
        await new Promise(resolve => setTimeout(resolve, 2000));
        this.fjReportModel.isShow = false;
        await this.getList()
        this.$message.success("任务处理中，请等待一定时间刷新该页面，在列表中下载")
      } catch (e) {
        this.$notify({ title: '任务处理失败', message: e.errormsg })
      }
    },
    onFjAddClose() {
      this.fjReportModel.isShow = false
    },

    async exportReport() {
      try {
        await this.$Api.post('generate_report', { project_id: this.project_id, site_type: this.sit })
        await new Promise(resolve => setTimeout(resolve, 2000));
        await this.getList()
        this.$message.success("任务处理中，请等待一定时间刷新该页面，在列表中下载")
      } catch (e) {
        this.$notify({ title: '任务处理失败', message: e.errormsg })
      }
    },
    async getList() {
      try {
        let params = {
          ...this.query,
          ...this.pagination,
          project_id: this.project_id
        };
        let data = await this.$Api.get("tasks", { params: params });
        this.pagination = {
          current_page: data.current_page,
          total: data.total,
          per_page: data.per_page
        }
        this.tableData = data.data;
      } catch (e) {
        this.$notify({ title: '获取列表错误', message: e.errormsg })
      }
    },
    async getProjectRole() {
      try {
        let res = await this.$Api.post('get_project_role', { project_id: this.project_id })
        if (res) {
          if (res.is_admin) {
            this.is_admin = true
          }
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    changePage() {
      this.getList();
    },
    changePageSize(size) {
      this.pagination.per_page = size;
      this.getList();
    },
    async getProject() {
      try {
        let res = await this.$Api.post('get_project', { project_id: this.project_id })
        if (res) {
          this.project_name = res.project_name
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    }
  },
  created() {
    this.project_id = this.$route.params.project_id
    this.getProject()
    this.getProjectRole()
    this.getList()
  }
}
</script>
<style scoped>
.ellipsis .cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
